// Mock data for No-Show Killer Landing Page

export const LINKS = {
  calendar: "https://cal.com/luis-miguel-morro-lopez/reunion-discover-automatizacion-con-ia",
  whatsapp: "https://wa.me/+34653129894"
};

export const heroContent = {
  headline: "Elimina el 80% de las 'Sillas Vacías' en tu Clínica Dental sin que tu Recepcionista levante el teléfono.",
  subheadline: "El Protocolo de Confirmación Omnicanal que recupera hasta 5.000€/mes en facturación perdida automatizando WhatsApp y SMS.",
  ctaPrimary: "Ver Disponibilidad y Agendar Demo",
  ctaSecondary: "¿Dudas rápidas? Hablar por WhatsApp"
};

export const calculatorDefaults = {
  minCitas: 1,
  maxCitas: 30,
  defaultCitas: 10,
  minValor: 50,
  maxValor: 500,
  defaultValor: 150
};

export const processSteps = [
  {
    id: 1,
    title: "Confirmación Inteligente",
    subtitle: "WhatsApp",
    description: "El paciente confirma con un clic.",
    icon: "MessageCircleCheck"
  },
  {
    id: 2,
    title: "Escalado de Seguridad",
    subtitle: "SMS/Email",
    description: "Si no responde, insistimos por otras vías.",
    icon: "ShieldCheck"
  },
  {
    id: 3,
    title: "Rescate de Citas",
    subtitle: "Automático",
    description: "Si cancela, negociamos nuevo hueco automáticamente.",
    icon: "CalendarCheck"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Dra. María García",
    clinic: "Clínica Dental Sonrisa Plus",
    location: "Madrid",
    quote: "En el primer mes recuperamos 3.200€ en citas que antes perdíamos. La inversión se pagó sola en 2 semanas.",
    result: "+3.200€/mes recuperados",
    avatar: "MG"
  },
  {
    id: 2,
    name: "Dr. Carlos Ruiz",
    clinic: "Odontología Avanzada",
    location: "Barcelona",
    quote: "Mi recepcionista ya no pierde horas llamando. Ahora todo es automático y los pacientes confirman al instante.",
    result: "80% menos llamadas",
    avatar: "CR"
  },
  {
    id: 3,
    name: "Dra. Ana Martínez",
    clinic: "Centro Dental Familiar",
    location: "Valencia",
    quote: "De 12 no-shows semanales bajamos a 2. La paz mental de tener la agenda blindada no tiene precio.",
    result: "83% menos ausencias",
    avatar: "AM"
  }
];

export const pricingContent = {
  title: "Tu Agenda Blindada Llave en Mano",
  setupPrice: "1.290€",
  monthlyPrice: "97€/mes",
  guarantee: "No cerramos el proyecto hasta que esté 100% operativo recuperando citas.",
  benefits: [
    "Configuración completa del sistema omnicanal",
    "Integración con tu software de gestión",
    "Mensajes personalizados con tu marca",
    "Secuencias de confirmación automatizadas",
    "Dashboard de métricas en tiempo real",
    "Soporte prioritario por WhatsApp",
    "Actualizaciones y mejoras incluidas",
    "Formación completa para tu equipo"
  ]
};

export const closingContent = {
  title: "¿Listo para dejar de perder facturación?",
  optionA: {
    label: "Decididos",
    button: "Agendar Sesión de Implementación"
  },
  optionB: {
    label: "Dudas",
    button: "Tengo una pregunta (WhatsApp)"
  }
};
